module.exports = __webpack_public_path__ + "static/media/image.30d055da.webp";